<template> 
  <div>
    <el-upload
      ref="uploadRef"
      :action="useOss?ossUploadUrl:minioUploadUrl"
      :data="useOss?dataObj:null"
      list-type="picture"
      :multiple="false" 
      :show-file-list="showFileList"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :on-preview="handlePreview"
      :limit="maxCount"
      :on-exceed="handleExceed"
      accept="image/*">
      <el-button size="small" type="primary" :loading="uploadLoading" icon="el-icon-upload" round>点击上传图片</el-button>
      <div slot="tip" class="el-upload__tip">支持 jpg/png 格式，宽高比例为1:1或3:4，且宽高均大于480px，大小2M内，最多 {{ maxCount }} 张，拖拽可以调整顺序</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="fileList[0].url" alt="">
    </el-dialog>
  </div>
</template>
<script>
  import {policy} from '@/api/oss'

  export default {
    name: 'singleUpload',
    props: {
      value: String,
      // 最大上传数量，singleUpload 场景默认 1 张
      maxCount: {
        type: Number,
        default: 1
      }
    },
    computed: {
      imageUrl() {
        return this.value;
      },
      imageName() {
        if (this.value != null && this.value !== '') {
          return this.value.substr(this.value.lastIndexOf("/") + 1);
        } else {
          return null;
        }
      },
      fileList() {
        return [{
          name: this.imageName,
          url: this.imageUrl
        }]
      },
      showFileList: {
        get: function () {
          return this.value !== null && this.value !== ''&& this.value!==undefined;
        },
        set: function (newValue) {
        }
      }
    },
    data() {
      return {
        dataObj: {
          policy: '',
          signature: '',
          key: '',
          ossaccessKeyId: '',
          // ★★★ 新增：STS 临时凭证必须携带的 security token，字段名固定为 x-oss-security-token ★★★
          // 缺少该字段时 OSS 会返回 InvalidAccessKeyId: The Security Token may be lost
          'x-oss-security-token': '',
          dir: '',
          host: '',
          // callback:'',
        },
        dialogVisible: false,
        uploadLoading: false, // 上传中状态，控制按钮 loading
        useOss:true, //使用oss->true;使用MinIO->false
        ossUploadUrl:'https://laodongjia.oss-cn-shenzhen.aliyuncs.com',
        minioUploadUrl:'http://localhost:8080/minio/upload',
      };
    },
    methods: {
      emitInput(val) {
        this.$emit('input', val)
      },
      handleRemove(file, fileList) {
        this.emitInput('');
      },
      handlePreview(file) {
        this.dialogVisible = true;
      },
      // 超过 maxCount 限制时的回调
      handleExceed(files, fileList) {
        this.$message.warning(`最多只能上传 ${this.maxCount} 张图片`);
      },
      // 上传失败回调：关闭 loading，提示用户
      handleUploadError(err, file, fileList) {
        this.uploadLoading = false;
        this.$message.error('上传失败，请重试');
        console.error('上传错误：', err);
      },
      beforeUpload(file) {
        let _self = this;
        if(!this.useOss){
          //不使用oss不需要获取策略
          return true;
        }
         // 文件类型校验（可选，根据提示只允许jpg/png）
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片！')
        return false
      }

      // 文件大小校验：限制 1MB
      const maxSize = 1 * 1024 * 1024 // 1MB
      if (file.size > maxSize) {
        this.$message.error(`上传文件不能超过 1MB！当前文件大小：${(file.size / 1024 / 1024).toFixed(2)}MB`)
        return false
      }

        // 进入上传流程，按钮置 loading
        this.uploadLoading = true;

        return new Promise((resolve, reject) => {
          policy().then(response => {
            _self.dataObj.policy = response.data.policy;
            _self.dataObj.signature = response.data.signature;
            _self.dataObj.ossaccessKeyId = response.data.accessKeyId;
            // ★★★ 关键修复：把 STS 临时凭证的 securityToken 写入表单字段 ★★★
            // 后端 OssServiceImpl.policy() 中已通过 result.setSecurityToken(...) 返回，
            // 前端必须原样使用 response.data.securityToken，字段名不能改成 securityToken
            _self.dataObj['x-oss-security-token'] = response.data.securityToken;
            _self.dataObj.key = response.data.dir + '/'+ file.name;
            _self.dataObj.dir = response.data.dir;
            _self.dataObj.host = response.data.host;
            // _self.dataObj.callback = response.data.callback;
            resolve(true)
          }).catch(err => {
            console.log(err)
            _self.uploadLoading = false;
            reject(false)
          })
        })
      },
      handleUploadSuccess(res, file) {
        this.uploadLoading = false;
        this.showFileList = true;
        this.fileList.pop();
        let url = this.dataObj.host + '/' + this.dataObj.dir + '/' + file.name;
        if(!this.useOss){
          //不使用oss直接获取图片路径
          url = res.data.url;
        }
        this.fileList.push({name: file.name, url: url});
        this.emitInput(this.fileList[0].url);
      }
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Upload/singleUpload.vue